// extracted by mini-css-extract-plugin
module.exports = {"UploadBox":"Withdrawal_UploadBox__1jieI","FullWidth":"Withdrawal_FullWidth__3ainC","TitleBox":"Withdrawal_TitleBox__8x_At"};